import { render, staticRenderFns } from "./pagoRealizado.vue?vue&type=template&id=65503998&scoped=true"
import script from "./pagoRealizado.vue?vue&type=script&lang=js"
export * from "./pagoRealizado.vue?vue&type=script&lang=js"
import style0 from "./pagoRealizado.vue?vue&type=style&index=0&id=65503998&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65503998",
  null
  
)

export default component.exports